import { ThemeMode } from '@modules/theme/constants';
import { Box } from '@mui/material';
import { useTheme } from '@mui/system';
import EmojiPicker, {
  EmojiClickData,
  Theme as EmojiPickerTheme,
} from 'emoji-picker-react';

const emojiPickerStyleOverrides = {
  '.EmojiPickerReact .epr-category-nav > button.epr-cat-btn': {
    backgroundImage: 'url("/dashboardEmojiCategories.svg")',
  },
  '.EmojiPickerReact .epr-search-container .epr-icn-search': {
    backgroundImage: 'url("/dashboardEmojiSearchIcon.svg")',
  },
};

interface DashboardEmojiPickerProps {
  onEmojiClick: (emoji: string) => void;
}

export const DashboardEmojiPicker = ({
  onEmojiClick,
}: DashboardEmojiPickerProps) => {
  const theme = useTheme();

  const handleEmojiClick = ({ emoji }: EmojiClickData) => onEmojiClick(emoji);

  return (
    <Box
      /*
       * emoji-picker-react injects certain images using CSS, which are not allowed
       * as per our CSP. This is fixed by having these images as public assets and
       * overriding the CSS image urls
       */
      sx={emojiPickerStyleOverrides}
    >
      <EmojiPicker
        theme={
          theme.palette.mode === ThemeMode.LIGHT
            ? EmojiPickerTheme.LIGHT
            : EmojiPickerTheme.DARK
        }
        onEmojiClick={handleEmojiClick}
      />
    </Box>
  );
};
